import { filtersHelper } from '@/utils';

export const propertyStatusModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    description: data.description,
    sequence: data.sequence,
    isOperational: data.is_operational,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    propertyCount: data.properties_count ? data.properties_count : '0',
});
